module.exports = __webpack_public_path__ + "img/60chickens.30d75328.svg";